import React, { Component } from 'react'
import commonMethod from '../lib/commonMethod'

class LibraryList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            libraryList: [],
        };

    }

    render() {

        let searchList = this.props.searchList;
        let data = this.props.data;
        let libraryList = this.props.libraryList;

        if (libraryList.length == 0) {
            return <p className="loading-text">loading..</p>;
        }

        // let libraryList = [
        //     {name:"Natural Language Search", type:"Natural Language Search"},
        //     {name:"Related Keywords", type:"Related Keywords"},
        //     {name:"Functions", type:"Functions"},
        //     // {name:"Physical Phenomena", type:"Physical Phenomena"},
        //     {name:"Research Papers", type:"Research Papers"},
        //     {name:"Biological Systems", type:"Biological Systems"},
        //     {name:"Products", type:"Products"},
        //     {name:"Physical Effect", type:"Physical Effect"},
        // ]

        // 자연어 검색 뒤에 자연어 검색 불가
        if (this.props.last) {
            let lastType = searchList[searchList.length - 1].type;
            if (lastType === "Natural Language Search") {
                libraryList[0].disabled = true;
            }
        } else if (data.type === "Natural Language Search") {
            libraryList[0].disabled = true;
        }

        // console.log(this.props.data && this.props.data.id);

        return (
            <ul className="library-list">
                {libraryList.map((v, k) => {
                    if (v.step_name == 'Biological Systems') {
                        v.step_name = 'Organisms'
                    }

                    return (
                        <li key={k}
                            onClick={() => !v.disabled && this.props.addLibrary(v.step_name, this.props.data && this.props.data.id, v.step_code)}
                            className={v.disabled ? "disabled" : ""}>
                            {v.step_name}
                        </li>
                    )
                })}
            </ul>
        )
    }
}


export default LibraryList;

